import { createSlice } from '@reduxjs/toolkit'

const experienceSlice = createSlice({
	name: 'experience',
	initialState: {
		experienceDetails: null,
		userPosition: null,
	},
	reducers: {
		setExperienceDetails: (state, action) => {
			state.experienceDetails = action.payload
		},
		setUserPosition: (state, action) => {
			state.userPosition = action.payload
		},
		clearExperienceState: (state) => {
			state.experienceDetails = null
			state.userPosition = null
		},
	},
})

export const { setExperienceDetails, setUserPosition, clearExperienceState } =
	experienceSlice.actions

export default experienceSlice.reducer
